"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
var change_type_1 = require("../../../core/cd/interface/change-type");
var prop_change_manager_1 = require("../../../core/cd/prop-change-manager");
var irender_reason_1 = require("../interface/irender-reason");
var type_function_1 = require("../../../core/lang/type-function");
exports.STATE = "STATE";
var StateTrait = /** @class */ (function () {
    function StateTrait() {
    }
    StateTrait.enableFor = function (instance) {
        var states = Object.getPrototypeOf(instance).constructor[exports.STATE] || [];
        for (var i = 0; i < states.length; i++) {
            StateTrait.initState(instance, states[i].name, states[i].type);
        }
    };
    StateTrait.addState = function (ctor, name, type) {
        if (process.env.NODE_ENV === "development") {
            if (core_1.st.dom.isStandardHTMLAttribute(name)) {
                core_1.st.error("The state " + ctor.name + "." + name + " is a standard HTML element attribute. It's value would be written directly to this.el, hiding away from @attr. Please choose a different name.");
            }
        }
        if (!ctor[exports.STATE]) {
            ctor[exports.STATE] = [];
        }
        ctor[exports.STATE].push({
            name: name,
            type: type,
        });
    };
    StateTrait.handleCustomElementStateChange = function (instance, change) {
        // call handler method if implemented
        if (typeof instance.onStateChange == type_function_1.TYPE_FUNCTION) {
            instance.onStateChange(change.name, change);
        }
        // if the instance never rendered yet, don't call doRender()!
        if (!instance.INTERNAL.notInitialRender)
            return;
        if (instance.shouldRender(irender_reason_1.RenderReason.STATE_CHANGE, {
            name: change.name,
            path: change.path,
            value: change.value,
            prevValue: change.prevValue,
            type: change.type,
        })) {
            instance.doRender();
        }
    };
    StateTrait.initState = function (instance, name, type) {
        prop_change_manager_1.PropChangeManager.onChange(instance, name, type, function (value, prevValue) {
            StateTrait.handleCustomElementStateChange(instance, {
                type: change_type_1.ChangeType.REFERENCE,
                path: prop_change_manager_1.DEFAULT_EMPTY_PATH,
                name: name,
                value: value,
                prevValue: prevValue,
            });
        }, function (path, value, prevValue) {
            StateTrait.handleCustomElementStateChange(instance, {
                type: change_type_1.ChangeType.DEEP,
                path: path,
                name: name,
                value: value,
                prevValue: prevValue,
            });
        });
    };
    return StateTrait;
}());
exports.StateTrait = StateTrait;
//# sourceMappingURL=state.js.map